import { scrollToId } from "../hooks/useSmoothScroll";
import { useLang } from "../hooks/useLanguage";
import { Reveal } from "./Reveal";

const WhoWeHelp = ({ onSelect }) => {
  const { t } = useLang();

  const partner = () => {
    onSelect("Partnership / Referral");
    scrollToId("consultation");
  };

  return (
    <section id="who" className="bg-ivory text-[#202020] py-24 md:py-32" data-testid="who-we-help-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <Reveal className="max-w-3xl">
          <p className="label-caps">{t.UI.whoLabel}</p>
          <h2 className="mt-4 font-serif-lux font-light text-[clamp(2rem,4.5vw,3.4rem)] leading-[1.08] tracking-tight">
            {t.UI.whoTitle}
          </h2>
        </Reveal>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#141414]/10 border hairline-light">
          {t.AUDIENCES.map((a, i) => (
            <Reveal key={a.title} delay={(i % 4) * 0.07} className="h-full">
              <div
                className={`h-full p-8 flex flex-col transition-[transform,background-color] duration-500 hover:-translate-y-1 ${
                  a.cta ? "bg-[#141414] text-ivory" : "bg-ivory hover:bg-white"
                }`}
                data-testid={`audience-card-${i + 1}`}
              >
                <span className="latin-text font-serif-lux text-4xl font-light text-champagne">0{i + 1}</span>
                <h3 className="mt-6 font-serif-lux text-2xl font-medium leading-snug">{a.title}</h3>
                <p className={`mt-3 text-sm leading-relaxed flex-1 ${a.cta ? "text-ivory/60" : "text-smoke"}`}>
                  {a.text}
                </p>
                {a.cta && (
                  <button
                    onClick={partner}
                    className="btn-lux btn-lux-outline mt-8 self-start !px-6 !py-3"
                    data-testid="become-partner-cta"
                  >
                    {t.UI.partnerCta}
                  </button>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeHelp;
